import { Avatar, Box, Group, LoadingOverlay, Menu, Text, UnstyledButton } from '@mantine/core';
import { IconChevronDown, IconLogout } from '@tabler/icons-react';
import cx from 'clsx';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { User } from '@e-origin/shared';

import { accountCircleIcon } from '@assets';
import { useDeclarant } from '@hooks/declarant';
import { useSignOut, useUser } from '@hooks/user';
import classes from './UserMenu.module.css';

export const UserMenu = () => {
  const [userMenuOpened, setUserMenuOpened] = useState(false);
  const { data: user } = useUser();
  const { data: declarant, isLoading } = useDeclarant();
  const navigate = useNavigate();
  const signOutMutation = useSignOut(() => navigate('/auth'));

  const handleLogout = () => signOutMutation.mutate();

  const displayName = (user?: User) => (user?.firstName || user?.lastName ? `${user?.firstName} ${user?.lastName}`.trim() : user?.email);

  if (!declarant) {
    return <LoadingOverlay visible={isLoading} overlayProps={{ radius: 'sm', blur: 2 }} />;
  }

  return (
    <Box mr={25}>
      <Menu
        position="bottom-end"
        transitionProps={{ transition: 'pop-top-right' }}
        onClose={() => setUserMenuOpened(false)}
        onOpen={() => setUserMenuOpened(true)}
        withinPortal
      >
        <Menu.Target>
          <UnstyledButton data-pw="user-dropdown-btn" className={cx(classes.user, { [classes.userActive]: userMenuOpened })}>
            <Group gap={7}>
              <Avatar src={accountCircleIcon} alt={displayName(user)} radius="xl" size={40} />
              <Text fw={500} size="sm" lh={1} mr={3}>
                {declarant?.accountName}
                <br />
                {displayName(user)}
              </Text>
              <IconChevronDown size={12} stroke={1.5} />
            </Group>
          </UnstyledButton>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item leftSection={<IconLogout size={16} stroke={1.5} />} onClick={handleLogout}>
            Logout
          </Menu.Item>
        </Menu.Dropdown>
      </Menu>
    </Box>
  );
};
